import Store from 'store/store'
import Bowser from 'bowser'

const browser = Bowser.getParser(window.navigator.userAgent)
const BROWSER_SUPPORT = Store.constants.current.BROWSER_SUPPORT

export default {
  name: browser.getBrowserName(),
  version: browser.getBrowserVersion(),
  isSupported: browser.satisfies(BROWSER_SUPPORT),
  isMobile: browser.is('mobile'),
  supported: Object.entries(BROWSER_SUPPORT).map(([name, version]) => ({ name, version }))
}



// WEBPACK FOOTER //
// ./src/controllers/browser.js